const views=new Map();
const TTL=90000;
let activeIdentity='';
export function activateBookingMemory(identity) {
  if(identity!==activeIdentity){views.clear();activeIdentity=identity;}
}
export function clearBookingMemory(){views.clear();}
export function bookingMemoryKey(identity,businessId,request){
  const {cursor,...filters}=request;
  return JSON.stringify([identity,businessId || '',filters]);
}
export function readBookingMemory(identity,key,now=Date.now()){
  if(!identity || identity!==activeIdentity)return null;
  const entry=views.get(key);
  if(!entry || now-entry.at>TTL){views.delete(key);return null;}
  return entry.snapshot;
}
export function writeBookingMemory(identity,key,snapshot,now=Date.now()){
  if(!identity || identity!==activeIdentity || snapshot.pageInfo?.legacyPending || snapshot.items.length>100)return;
  views.delete(key);views.set(key,{at:now,snapshot});
  while(views.size>12)views.delete(views.keys().next().value);
}
